import {
  changeAppStatus,
  createApp,
  deleteApp,
  postActiveDeliveryApp,
  postAppRenewal,
  postMerchantsAppRenewal,
  postMerchantsAppUpgrade
} from '@/api/app';
const Cookies = require('js-cookie');
const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop'
  },
  mutations: {
    TOGGLE_SIDEBAR: (state) => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1);
      } else {
        Cookies.set('sidebarStatus', 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device;
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR');
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation);
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device);
    },
    // 变更应用的上架状态
    ChangeStoreAppStatus(_, resdata) {
      return new Promise((resolve, reject) => {
        changeAppStatus(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 续费
    AppRenewal(_, resdata) {
      return new Promise((resolve, reject) => {
        postAppRenewal(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 商家续费
    MerchantsAppRenewal(_, resdata) {
      return new Promise((resolve, reject) => {
        postMerchantsAppRenewal(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 商家升级
    MerchantsAppUpgrade(_, resdata) {
      return new Promise((resolve, reject) => {
        postMerchantsAppUpgrade(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 主动交付
    ActiveDeliveryApp(_, resdata) {
      return new Promise((resolve, reject) => {
        postActiveDeliveryApp(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    DeleteStoreApp(_, resdata) {
      return new Promise((resolve, reject) => {
        deleteApp(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    CreateStoreApp(_, resdata) {
      return new Promise((resolve, reject) => {
        createApp(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js